var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',{attrs:{"title":_vm.$t('common.Condition')}},[_c('CardSection',[_c('BaseNodeProperties',{attrs:{"node":_vm.node,"readonly":_vm.readonly}})],1)],1),_c('Card',{attrs:{"title":_vm.$t('common.Filters'),"actions":[
      {
        label: _vm.$t('common.Add Filter'),
        onAction: _vm.addFilter,
        disabled: _vm.readonly
      }
    ]}},[_vm._l((_vm.node.filters),function(filter,index){return _c('FilterEditor',{key:index,attrs:{"doc":_vm.doc,"data":filter,"index":index,"readonly":_vm.readonly},on:{"remove":function($event){return _vm.removeFilterAt(index)}}})}),(!_vm.node.filters.length)?_c('CardSection',[_vm._v("\n      "+_vm._s(_vm.$t('common.No filters'))+"\n    ")]):_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }